import { render, staticRenderFns } from "./ModalSetupNotification.vue?vue&type=template&id=2c833d76&"
import script from "./ModalSetupNotification.vue?vue&type=script&lang=js&"
export * from "./ModalSetupNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports